var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('EntryForm',{attrs:{"androidMobile":_vm.androidMobile}}),_c('v-img',{staticClass:"packshot-footer",attrs:{"src":_vm.packShot,"contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }